import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=61e96432&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=61e96432&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e96432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e96432')) {
      api.createRecord('61e96432', component.options)
    } else {
      api.reload('61e96432', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=61e96432&scoped=true&", function () {
      api.rerender('61e96432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nav/Notifications.vue"
export default component.exports